import { useDiaryByIdQuery } from "@/features/diaries/api";
import PatientResultsTimeline from "@/features/diaries/components/PatientResultsTimeline";
import { createFileRoute } from "@tanstack/react-router";

const HomeResultsPage = () => {
    const { diaryId } = Route.useParams();
    const { data: diary } = useDiaryByIdQuery(diaryId);

    if (!diary) {
        return null;
    }

    return <PatientResultsTimeline diary={diary} />;
};

export const Route = createFileRoute("/_app/diaries/$diaryId/home/results")({
    component: HomeResultsPage,
});
